import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import IMyQuoteDetailResponse from "../../models/mi-cotizacion/IMyQuoteDetailResponse";
import { ApiEndpoint } from "../../services/servicioCotizador/api.endpoint";
import { catchError, map, Observable, of } from "rxjs";

@Injectable({
    providedIn: 'root'
})

export class NetworkingMyQuoteDetail {

    networkingOutput?: any;

    constructor(
        private httpClient: HttpClient,
        private apiEndpoint: ApiEndpoint
    ) { }

    getMyQuoteDetail(id: string): Observable<IMyQuoteDetailResponse> {
        const url = this.apiEndpoint.URL_SERVICE_QUOTER_MY_QUOTES();
        return this.httpClient.get<IMyQuoteDetailResponse>(`${url}/${id}`).pipe(
          catchError((error: any) => {
            throw error;
          })
        );
      }

      getImgProduct(data: string[]): Observable<any[]> {
        const url = this.apiEndpoint.URL_PRODUCT_COOMEVA();
        return this.httpClient.post<any>(`${url}`, {
            programas: data
        }).pipe(
            map((response: { data: any; }) => response.data || []

            ), 
            catchError(error => {
                this.networkingOutput.imgProductFailureNetworkingOutput(1, error ? error : "No se encontró programas");
                return of([]);
            })
        );
    }
    
}
